import { useLayoutEffect } from "react";
import "./film.scss";

const Film = () => {
    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    });

    return (
        <div className="film-page">
            <video
                className="film-video"
                controls
                playsInline
                autoPlay
                muted
            >
                <source
                    src="https://player.vimeo.com/progressive_redirect/playback/1172991355/rendition/1080p/file.mp4%20%281080p%29.mp4?loc=external&signature=d7ec7d9802f42a1487c97a5dd1212a969ac877da55d1ee48e55a37d88e60ef95"
                    type="video/mp4"
                />
            </video>
        </div>
    );
};

export default Film;
